export default __webpack_public_path__ + "static/media/014.15bb7d6b.jpg";